import type { SxProps, Theme } from '@mui/material/styles'
import { alpha } from '@mui/material/styles'

/**
 * Блоки заметок урока, когда урок не в статусе in_progress:
 * светлый, ненавязчивый «приглушённый» вид (читаемый текст, без тёмно-серых массивов).
 */

export const lessonNoteCardMutedSx: SxProps<Theme> = (theme) => ({
  bgcolor:
    theme.palette.mode === 'light'
      ? alpha(theme.palette.primary.main, 0.03)
      : alpha(theme.palette.common.white, 0.04),
  border: '1px solid',
  borderColor: alpha(theme.palette.divider, 0.65),
  boxShadow: 'none',
})

/** Заголовок карточки заметки в приглушённом режиме */
export const lessonNoteTitleMutedSx: SxProps<Theme> = (theme) => ({
  color: theme.palette.text.primary,
  opacity: theme.palette.mode === 'light' ? 0.88 : 0.9,
})

/** Подзаголовок / пояснение */
export const lessonNoteCaptionMutedSx: SxProps<Theme> = {
  color: 'text.secondary',
}

/** Иконки в шапке карточки */
export const lessonNoteIconMutedSx: SxProps<Theme> = (theme) => ({
  color: theme.palette.text.secondary,
  opacity: 0.95,
})

/** Кнопка сворачивания секции */
export const lessonNoteCollapseBtnMutedSx: SxProps<Theme> = (theme) => ({
  color: theme.palette.text.secondary,
})

/**
 * Область Editor.js: белый/светлый фон внутри карточки, чёткая граница,
 * без action.disabledBackground (он даёт слишком тёмный контраст в части тем).
 */
export const lessonNoteEditorHolderMutedSx: SxProps<Theme> = (theme) => ({
  backgroundColor:
    theme.palette.mode === 'light' ? theme.palette.common.white : alpha(theme.palette.grey[900], 0.45),
  borderColor: alpha(theme.palette.divider, 0.9),
})
